// import moment from 'moment';
import mocker from 'superagent-mocker';

// import { API_URL } from '../Constants';

// const fill = (length) => {
//   // eslint-disable-next-line prefer-spread
//   return Array.apply(null, { length }).map(Number.call, Number);
// };

const GET = {
  // [`${API_URL}/schedule/:product`]: {
  //   'slot_duration': 3600,
  //   // Create a fake schedule
  //   'slots': fill(30).reduce((memo, day) => {
  //     let date = moment().startOf('day').add({ days: day });
  //
  //     if (date.isSame(moment(), 'day')) {
  //       memo.push({
  //         start_time: date.toISOString(),
  //         available: Math.random() >= 0.5,
  //         label: 'Within 1 hour',
  //       });
  //     }
  //
  //     fill(12).forEach((hour) => {
  //       date = date.startOf('day').add({ hours: hour + 8 });
  //       memo.push({
  //         start_time: date.toISOString(),
  //         available: Math.random() >= 0.5,
  //       });
  //     });
  //     return memo;
  //   }, []),
  // },
};

const POST = {
  // [`${API_URL}/registrations`]: {},
};

export default function(superagent) {
  const mock = mocker(superagent);

  mock.timeout = 500;

  Object.keys(GET).forEach(key => {
    let response = GET[key];
    mock.get(key, () => {
      return { body: response };
    });
  });

  Object.keys(POST).forEach(key => {
    let response = POST[key];
    mock.post(key, () => {
      return { status: 201, body: response };
    });
  });
}



// WEBPACK FOOTER //
// ./src/redux/MockApiInterface.js